import React from 'react';
import { Grid } from '@mui/material';
import Banner from './components/Banner';
import Welcome from './components/Welcome';

const LandingPage: React.FC = () => (
  <Grid
    container
    direction="column"
    alignItems="center"
    wrap="nowrap"
    sx={{
      backgroundColor: '#fff',
      height: '100%',
      width: '100%',
      scrollBarWidth: '0px',
      '&::-webkit-scrollbar': {
        width: '0px',
        background: 'transparent',
        display: 'none',
      },
    }}
  >
    <Grid sx={{ width: '100%' }}>
      <Banner />
    </Grid>
    <Grid sx={{ display: 'flex', width: '100%', zIndex: 1 }}>
      <Welcome />
    </Grid>
  </Grid>
);

export default LandingPage;
